import React from 'react';
import Header from './Header';
import Footer from './Footer';
import CreateHTML from './docs/Create.md';
import ListHTML from './docs/List.md';
import OverviewHTML from './docs/Overview.md';
import TasksHTML from './docs/Tasks.md';
import DataHTML from './docs/Data.md';
import './Docs.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight,faArrowLeft } from '@fortawesome/free-solid-svg-icons';

class Docs extends React.Component {
  constructor(props) {
    super(props);

    const page = (window.location.href.match(/page=(.*);/) && window.location.href.match(/page=(.*);/)[1]) || 'overview';

    let pages = {
      overview: {html: OverviewHTML, next: { href: '/docs.html?page=create;', text: 'Creating links' }, previous: { href: '/', text: 'Home' }},
      create: {html: CreateHTML, next: { href: '/docs.html?page=list;', text: 'Listing reminders' }, previous: { href: '/docs.html?page=overview;', text: 'Overview' }},
      list: {html: ListHTML, next: { href: '/docs.html?page=tasks;', text: 'Your tasks' }, previous: { href: '/docs.html?page=create;', text: 'Creating links' }},
      tasks: {html: TasksHTML, next: { href: '/docs.html?page=data;', text: 'Data & security' }, previous: { href: '/docs.html?page=list;', text: 'Listing reminders' }},
      data: {html: DataHTML, next: { href: '/', text: 'Home' }, previous: { href: '/docs.html?page=tasks;', text: 'Your tasks' }},
    }

    this.state = { page: pages[page] };
  }

  componentDidMount() {
    document.querySelectorAll('.re-doc .content img').forEach(el => el.parentElement.classList = 're-img');
  }

  render() {
    return <>
      <Header />
      <div className="re-doc">
      <h3 className="re-doc-breadcrumb">Documentation</h3>
      <div className="content" dangerouslySetInnerHTML={ {__html: this.state.page.html } }>

      </div>

      <div className="re-nav">
        <a className="button is-pulled-left" href={this.state.page.previous.href}><FontAwesomeIcon icon={faArrowLeft} />&nbsp;&nbsp;{this.state.page.previous.text}</a>
        <a className="button is-primary is-pulled-right" href={this.state.page.next.href}>{this.state.page.next.text}&nbsp;&nbsp;<FontAwesomeIcon icon={faArrowRight} /></a>
      </div>
      </div>
      <Footer />
    </>
  }
}


module.exports = Docs;
